<template>
  <v-app>
    <AppSystem />
    <router-view />
  </v-app>
</template>
<script>
import AppSystem from '@/components/AppSystemBar'
import { eventBus } from '@/main'
export default {
  name: 'App',
  components: {
    AppSystem
  },
  mounted () {
    this.$vuetify.theme.dark = false
  },
  created () {
    eventBus.$on('APP_LOADING_START', callback => {
      eventBus.$emit('APP_BUTTON_START')
      eventBus.$emit('APP_PROGRESS_TOOLBAR_START')
    })
    eventBus.$on('APP_LOADING_END', () => {
      eventBus.$emit('APP_BUTTON_END')
      eventBus.$emit('APP_PROGRESS_TOOLBAR_END')
    })
  }
}
</script>
